module.exports = __webpack_public_path__ + "img/fuelConsumption.c20ceaf7.svg";